<template>
  <div>
    <div class="word-card" v-if="syllableList.length">
      <div class="word-title">{{ syllableList[0].word }}发音解决方案三</div>

      <div class="info-panel syllabary-panel">
        <span class="panel-label">🔗 温馨提示</span>
        <span class="panel-text">🔊该部分的音节拆分是根据英语的音节划分方式来划分的音标。目前没有完善，如果你发现对应字母有误，请以音节音标和音素音标为准。</span>
      </div>

      <!-- 音节 → 字母 → 音素 -->
      <div class="info-panel letter-panel">
        <span class="panel-label">🎵音节音标 / 🔤对应字母 / 🎵音素源码</span>
        <div class="syllable-list">
          <div v-for="(item, i) in syllableList" :key="i" class="syllable-row">
            <span class="cell pho-cell" @click="playWord(item.word)">{{ item.phonetics }}</span>
            <span class="arrow">➜</span>
            <span class="cell letter-cell" @click="headForSplit(item.phoneticParts)">{{ item.letterStr }}</span>
            <span class="arrow">➜</span>
            <span class="cell letter-cell" @click="headForSplit(item.phoneticParts)">{{ item.phonemeStr }}</span>
          </div>
        </div>
      </div>

      <!-- 发音相似单词 -->
      <div class="info-panel result-panel" v-if="similarSyllableArr.length">
        <span class="panel-label">🎯 发音相似单词（以发音为准）</span>
        <div class="similar-chips">
          <button
            v-for="(item, i) in similarSyllableArr"
            :key="i"
            class="similar-btn"
            :style="{ background: item.bgColor }"
            @click="showWordDetail(i)"
          >
            <span v-for="(c, k) in item.chars" :key="k" class="btn-letter">{{ c.ch }}</span>
          </button>
        </div>
      </div>

      <button class="back-btn" @click="$emit('back')">返回单词详解</button>
    </div>

    <div class="word-card empty-card" v-else>
      <span class="empty-icon">🏰</span>
      <span class="empty-text">暂无美式音节信息</span>
    </div>

    <!-- 浮动详情 -->
    <div class="float-tip" v-if="floatingData" @click="clearFloating">
      <div class="float-word">{{ floatingData.word }}</div>
      <div class="float-phonetic" v-if="floatingData.phoneticParts">/{{ floatingData.phoneticParts }}/</div>
      <div class="float-meaning">{{ floatingData.meaning }}</div>
    </div>
  </div>
</template>

<script>
import request from '../../utils/request'
import { normalizeNewlines } from '../../utils/similar'

const BTN_BGS = [
  'linear-gradient(135deg, #ffe3e3, #ffb3c1)',
  'linear-gradient(135deg, #d0ebff, #74c0fc)',
  'linear-gradient(135deg, #d3f9d8, #8ce99a)',
  'linear-gradient(135deg, #fff3bf, #ffd43b)',
  'linear-gradient(135deg, #e5dbff, #b197fc)',
  'linear-gradient(135deg, #ffd8a8, #ffa94d)'
]

export default {
  name: 'AmericanSyllable',
  data() {
    return {
      syllableList: [],
      similarSyllableArr: [],
      floatingData: null
    }
  },
  computed: {
    word() {
      return this.$store.state.word
    }
  },
  watch: {
    word(val) {
      if (val && val.trim()) this.searchSyllable(val)
    }
  },
  mounted() {
    const word = (this.$store.state.word || '').trim()
    if (word) this.searchSyllable(word)
  },
  methods: {
    async searchSyllable(word) {
      if (!word) return
      try {
        const res = await request.get('/wordSyllable/AmericanSyllable', { params: { word } })
        const list = res.wordSyllable || []
        this.syllableList = list
        if (list.length) {
          this.searchSimilar(list[0].phoneticParts)
        }
      } catch (e) {
        // 拦截器已提示
      }
    },

    headForSplit(phonetics) {
      this.clearFloating()
      this.searchSimilar(phonetics)
    },

    async searchSimilar(phonePart) {
      if (!phonePart) return
      try {
        const res = await request.get('/wordSyllable/SplitSyllable', {
          params: { word: this.$store.state.word, phonePart }
        })
        const list = res.SplitSyllable || res.data || []
        this.similarSyllableArr = list.map((item, idx) => {
          const w = String(item.word || '')
          const chars = w.split('').map((ch) => ({ ch }))
          return { ...item, chars, bgColor: BTN_BGS[idx % BTN_BGS.length] }
        })
        if (!list.length) this.$message.info('未找到相似单词')
      } catch (e) {
        // 拦截器已提示
      }
    },

    showWordDetail(index) {
      const item = this.similarSyllableArr[index]
      if (!item) return
      this.playWord(item.word)
      this.clearFloating()
      const meaning = normalizeNewlines(item.meaning || '暂无释义').split('\n')[0]
      this.floatingData = {
        word: item.word || '',
        meaning,
        phoneticParts: item.phonetic_parts || ''
      }
      this._floatingTimer = setTimeout(() => this.clearFloating(), 5000)
    },

    playWord(word) {
      if (!word) return
      const audio = new Audio(
        'https://dict.youdao.com/dictvoice?audio=' + encodeURIComponent(word) + '&type=1'
      )
      audio.play()
    },

    clearFloating() {
      if (this._floatingTimer) {
        clearTimeout(this._floatingTimer)
        this._floatingTimer = null
      }
      this.floatingData = null
    }
  }
}
</script>

<style scoped>
.syllable-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
}
.syllable-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.arrow {
  color: #a29bfe;
  font-weight: 800;
}
</style>
